module.exports = __webpack_public_path__ + "img/animation.1ee4c985.gif";